export const autosaveEnabledTypes: string[] = ['notebook']; // the value should be resourceType
// key: type in artiface service, value: type in user stores
export const autosaveResourceTypeMap: Record<string, string> = {
    notebook: 'draftNotebook',
};
